/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/IAchieveScoreDailyAuthority',[],function() {
    "use strict";

    var IAchieveScoreDailyAuthority = function () {
        this.ScoreRequired = 0;
    };

    return IAchieveScoreDailyAuthority;
});
